import React, {
    useMemo,
    useRef,
    useEffect,
    forwardRef,
    useImperativeHandle,
} from 'react';
import { PopupFilter } from '@fairygodboss/ui';

export const LocationFilter = forwardRef(
    (
        {
            locationsOpen,
            isLocationsOpen,
            locations,
            onLocationSelect,
            bodyRef,
            activeLocations,
            isSM,
        },
        ref
    ) => {
        const mountedFilters = useRef(activeLocations);

        useImperativeHandle(ref, () => ({
            setFilter: () => onLocationSelect(mountedFilters.current),
        }));

        useEffect(() => {
            mountedFilters.current = activeLocations;
        }, [activeLocations]);

        return useMemo(() => {
            const css = {};
            if (isSM) {
                css.marginRight = '20px';
            } else {
                css.paddingLeft = '6px';
                css.paddingRight = '10px';
            }

            return (
                <PopupFilter
                    data-qa="Jobs-Search-Location-Filter"
                    limitWidth
                    open={locationsOpen}
                    label="Locations"
                    labelName="Locations"
                    isMulti
                    options={locations?.map((c) => ({
                        label: c.displayName,
                        value: c.value,
                        count: c.count,
                    }))}
                    onFilterPress={() => {
                        onLocationSelect(mountedFilters.current);
                        isLocationsOpen(!locationsOpen);
                    }}
                    onPress={() => null}
                    selectionChange={(val) => {
                        if (!val.length && !locationsOpen) {
                            onLocationSelect(val);
                        }
                        mountedFilters.current = val;
                    }}
                    selector={bodyRef}
                    selection={activeLocations}
                    css={css}
                    filterRightAlign={!isSM}
                />
            );
        }, [
            activeLocations,
            bodyRef,
            locations,
            onLocationSelect,
            isLocationsOpen,
            locationsOpen,
            isSM,
        ]);
    }
);
